import {Base} from "@/api/Base"

const api = "userFee"

export class UserFeeAdd extends Base {
    path = api + "/add"
}

export class UserFeeList extends Base {
    path = api + "/list"
}

export class UserFeeEdit extends Base {
    path = api + "/edit"
}

